<template>
  <!-- POS -->
  <div
    v-if="party == 1"
    class="px-4 text-black border border-gray-200 shadow shadow-md bg-gray-50 is-flex is-justify-content-space-between is-align-items-center"
    :class="{ 'is-flex-direction-row-reverse': type == 'destination' }"
  >
    <div class="p-3 font-bold text-gray-400 border-r is-uppercase is-flex is-align-items-center" :class="[type == 'origin' ? 'is-flex-direction-row-reverse border-r ' : 'border-l']">
      <span> POS </span>
      <i class="mx-2 text-slate-400 fa-solid fa-shop"></i>
    </div>
    <a
      href=""
      @click.prevent="party_set[type] = useProcessStore().process?.document_data?.completed != 1 && type == 'origin' && useProcessStore().product_list.length == 0 ? !party_set[type] : false"
      v-if="!party_set[type]"
      class="p-3"
    >
      <span class="mx-3" v-if="useProcessStore().process.document_data?.[type + '_name']">{{ useProcessStore().process.document_data?.[type + "_name"] }}</span>
      <i class="mx-2 mt-2 text-gray-300 fa fa-caret-down"></i>
    </a>

    <div class="w-full p-3 is-flex" v-if="party_set[type] == true" :class="{ 'is-flex-direction-row-reverse': type == 'destination' }">
      <div class="select is-small is-flex-grow-1">
        <select v-model="useProcessStore().process[type]" @change="save_document_party_return(type, party)" class="w-full select-index">
          <option :value="null">Zgjidh POS</option>
          <option v-for="pos in useProcessStore().assigned_pos_list" :key="pos.guid" :value="pos.guid">
            {{ pos.name }}
          </option>
        </select>
      </div>
      <a href="" @click.prevent="party_set[type] = false">
        <i class="mx-2 mt-2 fas fa-caret-up"></i>
      </a>
    </div>
  </div>
  <!-- WAREHOUSE -->
  <div v-else-if="party == 2">
    <!-- <pre>{{useProcessStore().warehouse_types}}</pre> -->
    <div
      class="px-2 text-black border border-gray-200 shadow shadow-md bg-gray-50 is-flex is-justify-content-space-between is-align-items-center sm:flex-column md:flex-row"
      :class="{ 'is-flex-direction-row-reverse': type == 'destination' }"
    >
      <div class="p-3 font-bold text-gray-400 border-l is-flex is-align-items-center is-uppercase" :class="[type == 'origin' ? 'is-flex-direction-row-reverse border-r ' : 'border-l']">
        <span> Magazina </span>
        <i class="mx-2 text-slate-400 fa-solid fa-warehouse"></i>
      </div>
      <a
        href=""
        @click.prevent="
          party_set[type] = useProcessStore().process?.document_data?.completed != 1 && ((type == 'destination' && useProcessStore().product_list.length == 0) || type == 'origin') ? !party_set[type] : false
        "
        v-if="!party_set[type]"
      >
        <i class="mx-2 mt-2 text-gray-300 fas fa-caret-down"></i>
        <span class="" v-if="useProcessStore().process.document_data?.[type + '_name']">
          {{ useProcessStore().process.document_data?.[type + "_name"] }}
        </span>
      </a>
      <div class="w-full p-3 is-flex" v-if="party_set[type]" :class="{ 'is-flex-direction-row-reverse': type == 'origin' }">
        <a href="" @click.prevent="party_set[type] = false">
          <i class="mx-2 mt-2 fas fa-caret-up"></i>
        </a>
        <div class="select is-small is-flex-grow-1">
          <select @change="save_document_party_return(type, party)" v-model="useProcessStore().process[type]" class="w-full">
            <option :value="null">Zgjidh magazine</option>
            <optgroup
              v-for="w_type in useProcessStore().warehouse_types.filter((t) => {
                if (useProcessStore().process[type + '_type_facility'] != 0) {
                  return t.id == useProcessStore().process[type + '_type_facility'];
                } else return true;
              })"
              :key="w_type.id"
              :label="w_type.name"
            >
              <option v-for="warehouse in useProcessStore().warehouses_list.filter((w) => w.warehouse_facility == w_type.id)" :key="warehouse.guid" :value="warehouse.guid">
                {{ warehouse.name }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>
    </div>
    <div v-if="useProcessStore().selected_warehouse[type]" class="p-4">
      <div class="justify-between pl-2 border-b is-flex">
        <span class="font-thin">Adresa: </span>
        <span>{{ useProcessStore()?.selected_warehouse?.[type]?.location }}</span>
      </div>
      <div class="justify-between pl-2 border-b is-flex">
        <span class="font-thin">Qyteti: </span>
        <span>{{ useProcessStore()?.selected_warehouse?.[type]?.city_name }}</span>
      </div>
      <div class="justify-between pl-2 is-flex">
        <span class="font-thin">Menaxheri: </span>
        <span>{{ useProcessStore()?.selected_warehouse?.[type]?.manager_name }}</span>
      </div>
    </div>
  </div>

  <!-- SUPPLIER -->
  <div v-else-if="party == 3" class="text-black text-gray-100 shadow shadow-md is-flex is-justify-content-space-between is-align-items-center" :class="{ 'is-flex-direction-row-reverse': type == 'destination' }">
    <div class="p-3 font-bold text-gray-100 border-r is-uppercase is-flex is-align-items-center" :class="[type == 'origin' ? 'is-flex-direction-row-reverse border-r ' : 'border-l']">
      <span> Furnitori </span>
      <i class="mx-2 text-slate-400 fa-solid fa-truck"></i>
    </div>
    <a href="" @click.prevent="useProcessStore().process?.document_data?.completed != 1 ? (party_set[type] = !party_set[type]) : null" v-if="!party_set[type]" class="p-3">
      <span v-if="useProcessStore().process.document_data?.[type + '_name']" class="mx-2 text-black">
        {{ useProcessStore().process.document_data?.[type + "_name"] }}
      </span>
      <i class="mx-2 mt-2 text-gray-300 fas fa-caret-down"></i>
    </a>
    <div class="w-full p-3 is-flex" v-if="party_set[type] && useProcessStore().process?.document_data?.completed != 1" :class="{ 'is-flex-direction-row-reverse': type == 'destination' }">
      <div class="select is-small is-flex-grow-1">
        <select @change="save_document_party_return(type, party)" v-model="useProcessStore().process[type]" class="w-full">
          <option :value="null">Zgjidh furnitorin</option>
          <option v-for="supplier in useProcessStore().suppliers_list" :key="supplier.guid" :value="supplier.guid">
            {{ supplier.name }}
          </option>
        </select>
      </div>
      <a href="" @click.prevent="party_set[type] = false">
        <i class="mx-2 mt-2 fas fa-caret-up"></i>
      </a>
    </div>
  </div>

  <!-- CUSTOMER -->
  <div v-else-if="party == 4" class="bg-gray-500 shadow shadow-md is-flex is-justify-content-space-between is-align-items-center" :class="{ 'is-flex-direction-row-reverse': type == 'destination' }">
    <div class="p-3 font-bold text-gray-100 border-l is-flex is-align-items-center is-uppercase" :class="[type == 'origin' ? 'is-flex-direction-row-reverse border-r ' : 'border-l']">
      <a @click.prevent="useProcessStore().getCustomers()" href="" class="text-blue-100">Kliente</a>
      <i class="mx-2 text-blue-100 fa-solid fa-user"></i>
      <i @click="useProcessStore().createCustomer()" class="ml-2 cursor-pointer fa-solid fa-plus"></i>
    </div>
    <a
      href=""
      @click.prevent="
        party_set[type] = useProcessStore().process?.document_data?.completed != 1 ? !party_set[type] : false;
        useProcessStore().getCustomers();
      "
      v-if="!party_set[type]"
      class="p-3 text-white"
    >
      <i class="mt-2 fas fa-caret-down"></i>
      <span class="mx-3">{{ useProcessStore().process.document_data?.[type + "_name"] }}</span>
    </a>

    <div v-if="party_set[type] == true" class="w-full p-3">
      <input type="text" v-model="customerSearchInput" class="w-full input is-small" placeholder="Kerko klient..." />
      <div v-if="customerSearchInput && filteredCustomers.length > 0" class="absolute z-10 w-full mt-1 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-md max-h-48">
        <ul>
          <li v-for="customer in filteredCustomers" :key="customer.guid" class="px-4 py-2 cursor-pointer hover:bg-gray-100" @click="selectCustomer(customer)">
            {{ customer.name }}
            <small class="text-gray-500" v-if="customer.business_name && customer.name !== customer.business_name">({{ customer.business_name }})</small>
          </li>
          <li v-if="filteredCustomers.length === 0" class="px-4 py-2 text-gray-500">Nuk ka rezultate.</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="w-full select is-small is-flex-grow-1" v-if="useProcessStore().customers_search && party == 4">
    <select @change="save_document_party_return(type, party)" v-model="useProcessStore().process[type]" name="" id="" class="w-full border-2 border-green-100">
      <option :value="null">Zgjidh klientin</option>
      <!-- create optgroup based on type_id_name -->
      <optgroup v-for="type_id in useProcessStore().grouped_customers" :key="type_id.id" :label="type_id.name">
        <option
          v-for="customer in useProcessStore().customers_list.filter((c) => c.type_id == type_id.id && JSON.stringify(c).toLowerCase().includes(useProcessStore().customers_search_val.toLowerCase()))"
          :key="customer.guid"
          :value="customer.guid"
        >
          {{ customer.name }}
        </option>
      </optgroup>
      <!-- <option v-for="customer in useProcessStore().customers_list" :key="customer.guid" :value="customer.guid"> -->
      <!--   {{ customer.name }} -->
      <!-- </option> -->
    </select>
  </div>
  <div>
    <div v-for="att in useProcessStore().attributes[type]" :key="att.attribute_id" class="items-center justify-between px-2 py-1 border border-gray-200 is-flex attr-bg">
      <span class="uppercase is-size-7">{{ att.attribute_name }} </span>
      <span class="font-bold" v-if="att.type_id == 'text'">{{ att.attribute_value }}</span>
      <span class="font-bold" v-else-if="att.type_id == 'number'">{{ att.attribute_value }}</span>
      <span class="font-bold" v-else-if="att.type_id == 'checkbox'">
        <i class="fas" :class="[att.attribute_value == 1 ? 'text-green-500 fa-circle-check' : 'text-gray-300 fa-times']"></i>
      </span>
    </div>
  </div>
  <!-- BLOCK: Create Customer Modal Form -->
  <div
    class="fixed left-0 flex justify-center w-screen h-screen bg-black bg-opacity-50 top-14 items-top create-customer"
    style="z-index: 99"
    v-if="useProcessStore().toggleCreateCustomer"
    @click.self="useProcessStore().toggleCreateCustomer = false"
  >
    <DaForm
      v-if="useProcessStore().toggleCreateCustomer"
      class="p-1 mt-3 text-left bg-white rounded-md shadow-lg"
      @submitted="submitCustomer"
      style="max-height: 80vh; overflow: scroll"
      :form="useProcessStore().customer_create_form"
    >
    </DaForm>
  </div>
</template>

<script setup>
import { defineProps, reactive, inject, onBeforeMount, ref, watch } from "vue";
import { useProcessStore } from "@/stores/process";
import CustomersServices from "@/services/Customer";
import CategoriesServices from "@/services/Category";
import WarehousesServices from "@/services/Warehouse";

import DaForm from "@/components/daform/index.vue";

const props = defineProps(["party", "type"]);
var party_set = reactive({ origin: false, destination: false });
const toast = inject("toast");
const customerSearchInput = ref("");
const filteredCustomers = ref([]);

const debouncedFilterCustomers = ref(null);

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const filterCustomers = () => {
  if (!customerSearchInput.value) {
    filteredCustomers.value = [];
    return;
  }
  const searchTerm = customerSearchInput.value.toLowerCase();
  filteredCustomers.value = useProcessStore().customers_list.filter(
    (customer) => customer.name.toLowerCase().includes(searchTerm) || (customer.business_name && customer.business_name.toLowerCase().includes(searchTerm))
  );
};

debouncedFilterCustomers.value = debounce(filterCustomers, 200); // Adjust delay as needed

watch(customerSearchInput, () => {
  debouncedFilterCustomers.value();
});

const selectCustomer = (customer) => {
  useProcessStore().process[props.type] = customer.guid;
  useProcessStore().process.document_data = {
    ...useProcessStore().process.document_data,
    [`${props.type}_name`]: customer.name,
    [`${props.type}_type_id`]: customer.type_id,
  };
  party_set[props.type] = false;
  customerSearchInput.value = "";
  filteredCustomers.value = [];
  save_document_party_return();
};

const submitCustomer = async (form) => {
  var new_customer = await CustomersServices.createCustomer(form);
  party_set[props.type] = useProcessStore().process?.document_data?.completed != 1 ? !party_set[props.type] : false;
  await useProcessStore().getCustomers();
  useProcessStore().customers_list.push(new_customer);
  useProcessStore().toggleCreateCustomer = false;
  useProcessStore().process[props.type] = new_customer.guid;
  save_document_party_return();
};

function save_document_party_return() {
  useProcessStore()
    .save_document_party(props.type, props.party)
    .then(async () => {
      if (props.party == 2) {
        useProcessStore().selected_warehouse[props.type] = await WarehousesServices.getWarehouseData(useProcessStore().process[props.type]);
      }
      if (props.party == 4) {
        var selected_category = {};
        var customer = useProcessStore().customers_list.find((c) => c.guid === useProcessStore().process[props.type]);
        if (customer) {
          selected_category[customer.type_id] = true;
          useProcessStore().attributes[props.type] = await CategoriesServices.getCategoryAttributes(selected_category, customer);
        } else {
          useProcessStore().attributes[props.type] = []; // Clear attributes if no customer selected
        }
      }
      toast.show("Ndryshimi u ruajt me sukses.", {
        ...{ type: "success", duration: 4000 },
      });
    });
}

onBeforeMount(async () => {
  await useProcessStore().getCustomers();
});
</script>

<style>
.attr-bg {
  background: #ffffd5;
}

.select:not(.is-multiple):not(.is-loading)::after {
  z-index: 1 !important;
}
</style>
